/**
 * load to the console the steps we have completed
 */
export function logInfo(o: object | string, message: string) {
  console.groupCollapsed(`portal: ${message}`);
  console.dir(o);
  console.groupEnd();
}

/**
 * load to the console the steps we have completed
 */
export function logError(message: string) {
  console.error(`portal error: ${message}`);
}
